import { bandColor } from '@/lib/scoreBands';

/**
 * DimensionBars — the six production dimensions, as vertical bars.
 *
 * ── SIX, AND THE SIXTH IS MOBILE UX ─────────────────────────────────────────
 *
 * The spec's data slide labels its bars Nav / Visual / **Onboard** / Friction /
 * A11y / Conv. Onboarding stopped being assessable on 2026-07-15 — a flow
 * cannot be audited from a single page — and shipping it anyway is the defect
 * this repo has logged eight times, once for 33 days on the live homepage.
 * The sixth is Mobile UX. This is exception 1 in DECISIONS.md.
 *
 * The canonical order is `server._DIM_TO_FIELD`'s, mirrored in
 * backend/tests/test_six_dimensions.py, which sweeps this file.
 *
 * ── NO TREND, NO DELTA ──────────────────────────────────────────────────────
 *
 * A bar is a score at a moment. There is no second moment to compare it to;
 * see StatTile for why that is a component-shape decision and not a caution.
 */
export const SIX_DIMENSIONS = [
  { key: 'navigation', short: 'Nav', name: 'Navigation' },
  { key: 'visual_hierarchy', short: 'Visual', name: 'Visual Hierarchy' },
  { key: 'friction_points', short: 'Friction', name: 'Friction Points' },
  { key: 'accessibility', short: 'A11y', name: 'Accessibility' },
  { key: 'conversion_design', short: 'Conv.', name: 'Conversion Design' },
  { key: 'mobile_ux', short: 'Mobile', name: 'Mobile UX' },
];

export function DimensionBars({ scores = {}, height = 96, testId }) {
  return (
    <div className="uxa-dim-bars" data-testid={testId || 'dimension-bars'}>
      {SIX_DIMENSIONS.map((d) => {
        const raw = scores[d.key];
        // A dimension with no score is drawn as an empty track and SAID to be
        // unscored, rather than drawn at zero. Zero is a measurement; absent is
        // not, and the two must not look alike.
        const has = raw != null && !Number.isNaN(Number(raw));
        const value = has ? Math.max(0, Math.min(100, Math.round(Number(raw)))) : null;
        return (
          <div key={d.key} className="uxa-dim-bar">
            <div className="uxa-dim-bar__track" style={{ height }} aria-hidden="true">
              {has ? (
                <div
                  className="uxa-dim-bar__fill"
                  style={{ height: `${value}%`, background: bandColor(value) }}
                />
              ) : null}
            </div>
            <span className="uxa-dim-bar__label">{d.short}</span>
            <span className="uxa-dim-bar__value">
              {has ? value : <span title={`${d.name} was not scored`}>&mdash;</span>}
            </span>
            <span className="uxa-visually-hidden">
              {d.name}: {has ? `${value} out of 100` : 'not scored'}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default DimensionBars;
